import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os cadastros
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDados(cod_ibge, nu_cnes, mes, ano) {
  try {
    const { data } = await api.get(
      '/app/ras/' + cod_ibge + '/' + nu_cnes + '/' + mes + '-' + ano
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(cadastros, nu_cnes, mes, ano) {
  const titlePdf = 'RAS'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, '')
  const descriptionPdf = ''
  const headersPdf = ['PROCEDIMENTO', 'CBO', 'IDADE', 'QUANTIDADE']

  const dataPdf = cadastros.map(({ procedimento, cbo, idade, quantidade }) => ({
    procedimento,
    cbo,
    idade,
    quantidade,
  }))

  const table = utils.methods.createTablePdf(dataPdf)
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const informacoes = [
        { label: 'CNES', value: nu_cnes },
        { label: 'MÊS/ANO', value: `${mes}/${ano}` },
      ]

      verticalPosition = utils.methods.bodyPdf(
        doc,
        informacoes,
        verticalPosition
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
